import type { QueryClient } from "@tanstack/react-query";

// Prefixes include every page variant (filters and pagination) of each list.
const companyListKeys = [
  ["companies"], ["buyers"], ["clients"], ["/api/prospects"],
  ["/api/capital-providers"], ["cois"], ["coi-firm"],
] as const;

export function invalidateCompanyQueries(client: QueryClient, companyId: string) {
  return Promise.all([
    client.invalidateQueries({ queryKey: ["company", companyId] }),
    ...companyListKeys.map((queryKey) => client.invalidateQueries({ queryKey })),
    // Company names appear in contact lists; financial edits affect the dashboard.
    client.invalidateQueries({ queryKey: ["contacts"] }),
    client.invalidateQueries({ queryKey: ["/api/dashboard/overview"] }),
    client.invalidateQueries({ queryKey: ["financials-overview"] }),
    client.invalidateQueries({ queryKey: ["financials-fee-detail", companyId] }),
    client.invalidateQueries({ queryKey: ["financials-attributable"] }),
    // An EBITDA edit re-derives every IOI/LOI EV and the tracker rows.
    client.invalidateQueries({ queryKey: ["offers", companyId] }),
    client.invalidateQueries({ queryKey: ["buyer-tracker", companyId] }),
    // A stage edit adds a move to a prospect's history.
    client.invalidateQueries({ queryKey: ["record-summary", "company", companyId] }),
  ]);
}
